import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Generates an artist ID in the format: firstWord-uuidFirstPart
 * Example: "Poonam Choudhury" + "c4cceaad-3e80-4a8e-baf1-958d009f4e5b" → "poonam-c4cceaad"
 */
export function generateArtistId(fullName: string, uuid: string): string {
  const firstWord = fullName.split(' ')[0].toLowerCase();
  const uuidFirstPart = uuid.split('-')[0];
  return `${firstWord}-${uuidFirstPart}`;
}
